module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout.component.scss
// module id = ./src/app/layout/layout.component.scss
// module chunks = main